import { useEffect, useMemo, useState } from "react";

import Joi from "joi-browser";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";
import { Heading } from "V2.0/common/heading";
import Form from "V2.0/components/Form";
import cloudonix from "V2.0/images/cloudonix.png";

const buttonInfo = {
  label: "Connect Cloudonix",
  style: "entire-width",
};

const template = [
  {
    name: "domainId",
    type: "text",
    label: "Domain Id",
  },
  {
    name: "customerId",
    type: "text",
    label: "Customer Id",
  },
  {
    name: "apiKey",
    type: "text",
    label: "Api Key",
  },
  {
    name: "phoneNumbers",
    label: "Phone Numbers",
    type: "inputFieldList",
    addLabel: "+ Add Phone Number",
    addPlaceholder: "",
  },
];

const schema = {
  domainId: Joi.string().required().label("Domain Id"),
  customerId: Joi.string().required().label("Customer Id"),
  apiKey: Joi.string().required().label("Api Key"),
  phoneNumbers: Joi.array()
    .items(Joi.string().regex(/^[a-zA-Z0-9+]+$/))
    .min(1)
    .required()
    .label("Phone Numbers"),
};

export default function CloudonixForm(props) {
  const {
    cloudonixSettings,
    workspaceId,
    updateCloudonixSettings,
    isViewOnly,
  } = props;

  const [inputField, setInputField] = useState({
    domainId: "",
    customerId: "",
    apiKey: "",
    phoneNumbers: [],
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setInputField({
      domainId: cloudonixSettings.domainId,
      customerId: cloudonixSettings.customerId,
      apiKey: cloudonixSettings.apiKey,
      phoneNumbers: cloudonixSettings.phoneNumbers,
    });
  }, [cloudonixSettings]);

  const udpatedTemplate = useMemo(() => {
    if (!isViewOnly) {
      return template;
    }

    return template.map((field) => {
      return {
        ...field,
        disabled: isViewOnly,
      };
    });
  }, [isViewOnly]);

  const updatedButtonInfo = !isViewOnly ? buttonInfo : {};

  async function handleSave(data) {
    const payload = {
      telephonySettings: {
        telephonyProvider: "cloudonix",
        cloudonixSettings: data,
      },
    };

    const lifecycleCbs = {
      init: () => {
        setLoading(true);
        message.loading("Connecting Cloudonix");
      },
      success: () => {
        message.destroy();
        message.success("Cloudonix Connected");
        setLoading(false);
      },
      error: (e) => {
        message.destroy();
        setLoading(false);
        showErrorToast(e, "Failed to connect Cloudonix");
      },
    };

    updateCloudonixSettings(payload, workspaceId, lifecycleCbs);
  }

  return (
    <div className="border rounded-lg p-8">
      <div className="flex gap-x-2 items-center">
        <img
          src={cloudonix}
          width={40}
        />
        <Heading>Connect Cloudonix</Heading>
      </div>
      <Form
        key={JSON.stringify(inputField)}
        errorMessage={{}}
        inputField={inputField}
        template={udpatedTemplate}
        schema={schema}
        buttonInfo={updatedButtonInfo}
        onSubmit={handleSave}
        loading={loading}
        setLoading={setLoading}
      />
    </div>
  );
}
